/**
 * Generates ids of infographs, pages, widgets.
 *
 * All above ids are fixed at 28 chars long.
 */
import { customAlphabet } from 'nanoid';
import { InfographId, PageId, WidgetId } from 'types/idTypes';
import { WidgetType } from 'types/widget.types';

const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
const nanoid = customAlphabet(alphabet, 28);

/**
 * Generate new infograph id.
 */
export function newInfographId(): InfographId {
  return nanoid();
}

/**
 * Generate new page id.
 */
export function newPageId(): PageId {
  return nanoid();
}

/**
 * Generate new infograph id.
 */
export function newWidgetId(t: WidgetType): WidgetId {
  return `${t}.${nanoid(24)}`;
}

/**
 * Generate new generation id.
 */
export function newGenerationId(): string {
  return nanoid();
}
